import React, { useCallback } from "react";
import styles from "./styles.module.scss";
import { useIsMobile } from "@/util-react/useIsMobile";
import whatsAppIcon from "@/assets/whatsapp.svg";
import { Icon } from "@/elements-react/fix-icon";
import { useServices } from "@/services-context.tsx";
import { useTranslation } from "react-i18next";

interface WhatsAppIconProps {
  className?: string;
}

const WhatsAppIcon: React.FC<WhatsAppIconProps> = ({ className = "" }) => {
  const isMobile = useIsMobile();
  const { customerChannel, formatter } = useServices();
  const { t } = useTranslation();

  if (!customerChannel.whatsappPhone) {
    return;
  }

  const handleClick = useCallback(() => {
    const encodedMessage = encodeURIComponent(t("nayfuojq3bgawuis.have-a-question", "Hello! I have a question about your products"));
    const encodedPhone = formatter.phoneCleaner(customerChannel.whatsappPhone!);

    window.open(`https://wa.me/${encodedPhone}?text=${encodedMessage}`, "_blank");
  }, []);

  return (
    <div className={`${isMobile && styles.mobile} ${styles.whatsappContainer} ${className}`}>
      <div className={styles.tooltip}>
        <div className={styles.tooltipTitle}>{t("anc8948aigrvb894.have-a-question", "Have a question?")}</div>
        <div className={styles.tooltipText}>{t("bcgf6we747gf4879.send-message-on-whatsapp", "Send us a message on WhatsApp")}</div>
      </div>
      <button className={styles.whatsappButton} onClick={handleClick} type="button" aria-label={t("bcgf6we747gf4879.send-message-on-whatsapp", "Send us a message on WhatsApp")}>
        <Icon src={whatsAppIcon} height={40} width={40} />
      </button>
    </div>
  );
};

export default WhatsAppIcon;
